export interface EfemLockOwnershipStatus {
  isLocked?: boolean;
  lockedBy?: string;
  lockedByUserId?: number;
}

export interface CurrentEfemLockUser {
  id: number | null;
  email: string | null;
}

export function readCurrentEfemLockUser(): CurrentEfemLockUser {
  const userStr = localStorage.getItem('wafer_inventory_user');
  if (!userStr) {
    return { id: null, email: null };
  }

  try {
    const user = JSON.parse(userStr) as { id?: number | string; email?: string };
    const id = user.id == null ? null : Number(user.id);
    return {
      id: Number.isFinite(id) ? id : null,
      email: user.email ?? null,
    };
  } catch {
    return { id: null, email: null };
  }
}

export function isEfemLockOwnedByCurrentUser(
  lockStatus: EfemLockOwnershipStatus,
  currentUser: CurrentEfemLockUser,
): boolean {
  if (currentUser.id != null && lockStatus.lockedByUserId != null) {
    return Number(lockStatus.lockedByUserId) === Number(currentUser.id);
  }

  if (currentUser.email && lockStatus.lockedBy) {
    return lockStatus.lockedBy.toLowerCase() === currentUser.email.toLowerCase();
  }

  return false;
}
